import type { EntityId } from "../types";

export const toIdString = (id: EntityId | null | undefined): string => (id == null ? "" : String(id));

export const sameId = (left: EntityId | null | undefined, right: EntityId | null | undefined): boolean => {
  const leftId = toIdString(left);
  const rightId = toIdString(right);
  return Boolean(leftId && rightId && leftId === rightId);
};

export const resolveEntityId = <T extends { id?: EntityId | null; uuid?: EntityId | null }>(
  entity: T | null | undefined
): EntityId | null => entity?.id ?? entity?.uuid ?? null;
